"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostLoginChannel = void 0;
const topic_1 = require("../../topic");
const POST_LOGIN_CHANNEL = 'postLogin';
class PostLoginChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = POST_LOGIN_CHANNEL;
        this.topics = {
            completeAction: new topic_1.Topic('completeAction', POST_LOGIN_CHANNEL, this._logger),
        };
    }
}
exports.PostLoginChannel = PostLoginChannel;
//# sourceMappingURL=post-login.channel.js.map